import React from 'react'
import { AreaChart as AreaChartVictory } from './Victory/AreaChart/AreaChart'
import { PieChart as PieChartVictory } from './Victory/PieChart/PieChart'
import { BarChart as BarChartVictory } from './Victory/BarChart/BarChart'

export type IChartProvider = 'victory' | 'highcharts'

// #region Area Chart
export const AreaChartWrapper = ({
    data,
    color,
    provider,
}: {
    data: any | any[] | undefined,
    color: string,
    provider: IChartProvider,
}) => {
    if (data === undefined) {
        return <div>
            Chart data is not defined
        </div>
    } else {
        // console.log('AreaChart ', data)
    }
    return provider === 'victory'
        ? <AreaChartVictory data={data} color={color} />
        : <AreaChartVictory data={data} color={color} />
}
AreaChartWrapper.defaultProps = {
    provider: 'victory'
}
// #endregion

//#region Pie Chart
export const PieChartWrapper = ({
    data,
    provider,
    ...rest
}: {
    data: any | any[] | undefined,
    provider: IChartProvider,
    centerElement?: React.ReactNode,
    rest?: any
}) => {
    if (data === undefined) {
        return <div>
            Chart data is not defined
        </div>
    }

    return provider === 'victory'
        ? <PieChartVictory data={data} centerElement={rest.centerElement} {...rest} />
        : <PieChartVictory data={data} {...rest} />
}

PieChartWrapper.defaultProps = {
    provider: 'victory'
}
// #endregion

// #region Bar Chart
export const BarChartWrapper = ({
    data,
    color,
    provider,
}: {
    data: any | any[] | undefined,
    color: string;
    provider: IChartProvider
}) => {
    if (data === undefined) {
        return <div>
            Chart data is not defined
        </div>
    }

    return provider === 'victory'
        ? <BarChartVictory data={data} color={color} />
        : <BarChartVictory data={data} color={color} />
}
BarChartWrapper.defaultProps = {
    provider: 'victory'
}
// #endregion